import { ClientFormStatus } from "../types/formTemplates";

/**
 * Canonical status → {label, color} mapping for any UI that renders a client
 * form's status badge. Single source of truth — keep colors in sync across
 * Forms & Waivers tab, SOAP Notes tab, appointment-detail forms panel, etc.
 *
 * `color` is a Mantine palette key (`"gray"`, `"blue"`, `"orange"`, etc.) so
 * callers can pass it straight to `<Badge color={...} />`.
 */
export function clientFormStatusTag(status: ClientFormStatus | string): {
  label: string;
  color: string;
} {
  switch (status) {
    case "not_started":
    case "unopened":
      return { label: "Not started", color: "gray" };
    case "opened":
    case "viewed":
      return { label: "Opened", color: "blue" };
    case "edited":
    case "in_progress":
      return { label: "In Progress", color: "orange" };
    case "awaiting_staff":
      return { label: "Awaiting staff input", color: "orange" };
    case "awaiting_client":
      return { label: "Awaiting client input", color: "blue" };
    case "submitted":
    case "completed":
      return { label: "Completed", color: "green" };
    case "expired":
    case "past_expiry":
      return { label: "Expired", color: "red" };
    default:
      return {
        label:
          typeof status === "string" && status.length > 0
            ? status.replace(/_/g, " ")
            : "Unknown",
        color: "gray",
      };
  }
}
